document.addEventListener('DOMContentLoaded', function() {
    const extraText = document.querySelector('.collection-grid .extra-text');
    const readMore = document.querySelector('.collection-grid .read-more');

    if (extraText && readMore) {
        readMore.addEventListener('click', () => {
            extraText.classList.add('open'); // Zorgt ervoor dat de extra tekst zichtbaar wordt
            readMore.remove(); // Verwijdert de knop na klikken
        });
    }

    function updateCollectionBannerHeight() {
        const collectionBanner = document.querySelector('.collection-grid .featured-image img');
        const collectionProductImage = document.querySelector('.collection-grid .ed-product-block img');

        if (collectionBanner && collectionProductImage) {
            collectionBanner.style.height = collectionProductImage.offsetHeight + 'px';
        }
    }

    updateCollectionBannerHeight();
    window.addEventListener('resize', updateCollectionBannerHeight);

    // 🔥 Re-run after filtering
    const observer = new MutationObserver(() => {
        updateCollectionBannerHeight();
    });

    observer.observe(document.getElementById('ProductGridContainer'), { childList: true, subtree: true });
});
